export default __webpack_public_path__ + "static/media/whatisDNS.18d4e0f8.md";